import { IFormData } from '../../components/FormHelper/FormHelper.types';
import { BaseApiResponse } from '../../types/api.types';
import { ICamp } from '../../types/camp.types';
import instance from './axios';

type ActivitiesProps = {
  camp_id?: number;
  start_time?: string;
  end_time?: string;
  type?: 'today' | 'this-week';
  is_paid?: boolean;
};

const ENDPOINTS = {
  ACTIVITIES: '/activities',
  ACTIVITY_TYPES: '/activity-types',
  SETTING_BOOKING: 'settings/booking',
};

const getActivities = (props: ActivitiesProps) => {
  return instance.get<BaseApiResponse>(ENDPOINTS.ACTIVITIES, {
    params: props,
  });
};

const getActivity = (id: number) => {
  return instance.get<BaseApiResponse>(ENDPOINTS.ACTIVITIES + '/' + id);
};

const getActivityTypes = () => {
  return instance.get<BaseApiResponse>(ENDPOINTS.ACTIVITY_TYPES);
};

const postSignupActivity = (id: number) => {
  return instance.post<BaseApiResponse>(
    ENDPOINTS.ACTIVITIES + '/' + id + '/signup'
  );
};

const getBookingSetting = () => {
  return instance.get<BaseApiResponse>(ENDPOINTS.SETTING_BOOKING);
};

const ActivityApi = {
  getActivities,
  getActivity,
  postSignupActivity,
  getActivityTypes,
  getBookingSetting,
};

export default ActivityApi;
